"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestBackOff = void 0;
var ark_request_1 = require("@tencent/ark-request");
/**
 * 目前的延迟退避策略如下：
 * 1. network timeout 类型，超时的立即重试，不进行退避；
 * 2. 非 200 的响应码 + 网络断开场景，按指定退避策略；
 */
var RequestBackOff = /** @class */ (function (_super) {
    __extends(RequestBackOff, _super);
    function RequestBackOff() {
        return _super.call(this, 0) || this;
    }
    RequestBackOff.prototype.next = function (context) {
        var result = context.result, attempt = context.attempt;
        if (!result) {
            // 没有异常信息，不进行退避处理
            return undefined;
        }
        // 非 error 类的异常，不进行退避处理（目前理论上不会走到这个分支）
        if (!('error' in result)) {
            return undefined;
        }
        var error = result.error;
        // 1. 请求超时的异常，立即进行重试
        if (error.code === ark_request_1.REQUEST_ERROR_CODE.timeout) {
            this.duration = 0;
            return this;
        }
        // 2. 非 200 的响应码 + 网络断开场景，按 重试次数 * 2 的退避算法重试
        this.duration = Math.min(2 * attempt, 30) * 1000;
        return this;
    };
    return RequestBackOff;
}(ark_request_1.BaseBackoff));
exports.RequestBackOff = RequestBackOff;
